import React, {useContext, useState} from "react";
import {Modal} from 'react-bootstrap'
import {DynamicComponentProps} from "../../core/_models";
import {KTSVG} from "../../../../../_metronic/helpers";

export function PdfComponent({config, context}: DynamicComponentProps) {
    const {value, readOnly, id, withPreview, label} = config;
    const [modal, setModal] = useState(false);

    const [pdf, setPdf] = useState(value);

    const formContext = useContext(context);

    const encodePdfFileAsURL = (element: HTMLInputElement) => {
        if (element.files == null) {
            return
        }

        const file = element.files[0];
        const reader = new FileReader();
        reader.onloadend = function () {
            const result = reader.result;
            setPdf(result);
            formContext.set(id, result);
        }
        reader.readAsDataURL(file);
    }

    return (
        <div>
            {label && <div>{label}</div>}
            {pdf && withPreview !== false &&
                <div className='embed-responsive position-relative'>
                    <iframe
                        title='PDF'
                        src={pdf}
                        style={{width: '100%', height: '600px', border: '1px solid #eff2f5'}}
                    />
                    <button
                        type='button'
                        className='btn btn-sm btn-icon btn-light position-absolute top-0 end-0 m-2'
                        title='Fullscreen'
                        onClick={() => setModal(true)}
                    >
                        <KTSVG className='svg-icon-2' path='/media/icons/duotune/general/gen004.svg'/>
                    </button>
                </div>}
            {!readOnly &&
                <div className="py-2"><input type="file" accept="application/pdf" onChange={(e) => encodePdfFileAsURL(e.target)}/></div>}
            {modal && <Modal
                id='kt_pdf_preview_modal'
                tabIndex={-1}
                aria-hidden='true'
                dialogClassName='modal-dialog modal-dialog-centered mw-1000px'
                show={true}
                onHide={() => setModal(false)}
            >
                <div className='modal-header'>
                    <h2>PDF Viewer</h2>
                    {/* begin::Close */}
                    <div className='btn btn-sm btn-icon btn-active-color-primary' onClick={() => setModal(false)}>
                        <KTSVG className='svg-icon-1' path='/media/icons/duotune/arrows/arr061.svg'/>
                    </div>
                    {/* end::Close */}
                </div>
                <div className='modal-body py-lg-10 px-lg-10'>
                    <iframe
                        title='PDF Preview'
                        src={pdf}
                        style={{width: '100%', height: '80vh', border: 'none'}}
                    />
                </div>
            </Modal>}
        </div>
    )
}
